import { request } from '@/utils/request'

// 获取官网资讯列表
export function getOfficialWebsiteInfomationList(params) {
  return request({
    url: '/infomation/notAuth/getOfficialWebsiteInfomationList',
    method: 'get',
    params: params
  })
}

// 根据编号获取资讯详情
export function getOfficialWebsiteInfomationInfo(id) {
  return request({
    url: '/infomation/notAuth/getOfficialWebsiteInfomationInfo',
    method: 'get',
    params: { infoNo: id }
  })
}